import { CARD_CREATE_SUCCESS } from '../../../actions/cards/create';
import type { Action } from '../../../types';
import type { LastCreatedCardIdState } from './types';

export default function lastCreatedCardIdReducer(
	state: LastCreatedCardIdState = null,
	action: Action,
): LastCreatedCardIdState {
	switch (action.type) {
		case CARD_CREATE_SUCCESS:
			return action.payload.card.id;

		default:
			return state;
	}
}
